import type { ApiLivestreamItem } from '../../api/erp';
type LiveStock = Pick<ApiLivestreamItem, 'reserved_quantity' | 'reserved_fulfilled_quantity' | 'location_available_quantity'>
    & Partial<Pick<ApiLivestreamItem, 'sold_quantity' | 'selection_metadata' | 'source' | 'sellable_quantity'>>;

const LOCKED_STATUSES = ['live', 'completed'];

/** After labeling, held stock is the remaining unsold allocation for this live.
 * Sold units have already been deducted from the allocation by order returns. */
export function liveSellableQuantity(item: LiveStock, status?: string): number {
    if (item.sellable_quantity != null) return Math.max(0, item.sellable_quantity);
    const held = Math.max(0, item.reserved_fulfilled_quantity ?? 0);
    if (status && LOCKED_STATUSES.includes(status)) return held;
    return Math.min(Math.max(0, item.reserved_quantity ?? 0), held + Math.max(0, item.location_available_quantity ?? 0));
}

/** Zero present stock is only an unavailable listing after labeling has started. */
export function isLiveItemUnavailable(item: LiveStock, status?: string): boolean {
    return !!status && LOCKED_STATUSES.includes(status) && liveSellableQuantity(item, status) === 0;
}

/** Manual label printing is available even for unpurchased or unavailable goods. */
export function liveLabelCount(item: LiveStock, status?: string): number {
    if (item.source === 'order_return') return Math.max(1, item.sold_quantity ?? 0);
    return Math.max(1, item.reserved_quantity ?? 0, item.reserved_fulfilled_quantity ?? 0);
}

/** Preserve saved live availability filters while merging them into product status. */
export function liveProductFilters(values:Record<string,string>,status?:string) {
    const legacy=status==='live'?(values.quantity||'').split(',').flatMap(value=>value==='available'?['in_stock']:value==='unavailable'?['no_stock']:[]):[];
    return {productStatus:values.productStatus||legacy.join(','),quantity:status==='completed'?(values.quantity||'').split(',').filter(value=>['sold','unsold'].includes(value)).join(','):''};
}
